var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('appheader',{attrs:{"index":"0"}}),_c('zlf-search'),_c('about'),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }